export default "__VITE_ASSET__8b990e1a__"